module.exports = __webpack_public_path__ + "static/media/vertical-dots.1a188a94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vertical-dots.svg
// module id = 2463
// module chunks = 0